import { ApiProperty } from "@nestjs/swagger";
import { DeviceReq } from "./device-req";

export class TempDeviceRequest{
    @ApiProperty()
    type:string;
    @ApiProperty()
    operation:string;
    @ApiProperty()
    data:DeviceReq
}